import {
  Box,
  Button,
  Dialog,
  IconButton,
  styled,
  Typography,
} from '@mui/material';

const protoPurple = '#6D28D9';
const protoPurpleDark = '#4C1D95';
const protoPurpleLight = '#F3E8FF';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: '#FFFFFF',
    padding: '24px 32px 32px',
    maxWidth: '520px',
    width: '100%',
  },
}));

export const CloseButton = styled(IconButton)(() => ({
  alignSelf: 'flex-end',
  color: protoPurple,
  backgroundColor: protoPurpleLight,
  width: '32px',
  height: '32px',

  '& span': {
    fontSize: '18px',
  },
}));

export const ProgressContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '6px',
  marginTop: '8px',
}));

export const ProgressDash = styled('span')<{ isActive: boolean }>(
  ({ isActive }) => ({
    width: isActive ? '24px' : '8px',
    height: '8px',
    borderRadius: '4px',
    backgroundColor: isActive ? protoPurpleDark : '#D9D9D9',
    transition: 'width 0.2s',
  })
);

export const Badge = styled('span')(() => ({
  alignSelf: 'center',
  backgroundColor: protoPurpleLight,
  color: protoPurple,
  borderRadius: '8px',
  padding: '4px 12px',
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  marginTop: '20px',
}));

export const CardTitle = styled(Typography)(() => ({
  color: '#1A1A1A',
  fontSize: '20px',
  fontWeight: 600,
  lineHeight: '140%',
  textAlign: 'center',
  marginTop: '12px',
}));

export const CardDescription = styled(Box)(() => ({
  color: '#475467',
  fontSize: '14px',
  lineHeight: '150%',
  textAlign: 'center',
  marginTop: '8px',

  '& p': {
    margin: 0,
  },
}));

export const MediaBox = styled(Box)(() => ({
  position: 'relative',
  borderRadius: '12px',
  overflow: 'hidden',
  marginTop: '20px',
  backgroundColor: '#1A1A2E',
  aspectRatio: '16 / 9',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },

  '& .play-icon': {
    position: 'absolute',
    color: '#FFFFFF',
    fontSize: '48px',
    opacity: 0.9,

    '& span': {
      fontSize: '48px',
    },
  },
}));

export const NavigationContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '16px',
  paddingBottom: '16px',
  borderBottom: '1px solid #EAECF0',
  color: '#475467',
  fontSize: '14px',

  '& button': {
    color: protoPurple,
  },

  '& button.Mui-disabled': {
    color: '#D9D9D9',
  },
}));

export const FooterContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '20px',
}));

export const ViewLaterButton = styled(Button)(() => ({
  backgroundColor: 'transparent',
  border: `1px solid ${protoPurple}`,
  color: protoPurpleDark,
  width: 'fit-content',
  height: '44px',
  padding: '10px 24px',
  fontSize: '14px',
  fontWeight: 600,
  display: 'flex',
  gap: '8px',

  '& span': {
    fontSize: '18px',
  },

  '&:hover': {
    backgroundColor: protoPurpleLight,
    color: protoPurpleDark,
  },
}));

export const ConfirmButton = styled(Button)(() => ({
  backgroundColor: protoPurpleDark,
  color: '#FFFFFF',
  width: 'fit-content',
  height: '44px',
  padding: '10px 32px',
  fontSize: '14px',
  fontWeight: 600,

  '&:hover': {
    backgroundColor: protoPurple,
  },
}));
